import {
  Bug,
  CarFront,
  Droplets,
  HeartHandshake,
  PackageOpen,
  Paintbrush,
  PlugZap,
  Settings2,
  Shirt,
  Sparkles,
  TreePine,
  Truck,
  Wrench,
} from "lucide-react";
import { Link } from "react-router-dom";

const icons = { Bug, CarFront, Droplets, HeartHandshake, PackageOpen, Paintbrush, PlugZap, Settings2, Shirt, Sparkles, TreePine, Truck, Wrench };

export default function ServiceCard({ service, compact = false }) {
  const Icon = icons[service.icon] || Wrench;
  return (
    <article className={`service-card ${compact ? "service-card-compact" : ""}`} data-testid={`service-card-${service.slug}`}>
      <div className="service-card-top">
        <span className="service-number">{service.number}</span>
        <span className="service-icon"><Icon size={23} strokeWidth={1.7} /></span>
      </div>
      <h3>{service.name}</h3>
      <p>{service.description}</p>
      <div className="service-card-actions">
        <Link to={`/servicos/${service.slug}`} className="text-link" data-testid={`service-learn-more-${service.slug}`}>
          Saber Mais <span aria-hidden="true">↗</span>
        </Link>
        <Link to={`/marcar-servico?servico=${service.slug}`} className="card-book-link" data-testid={`service-book-${service.slug}`}>
          Marcar Serviço
        </Link>
      </div>
    </article>
  );
}
